import React from 'react';

class Header extends React.Component {
  render() {
    return (
      <header className="header">
        <h1>ToDo ReactApp</h1>
      </header>
    );
  }
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js